export default "__VITE_ASSET__Df97VFVL__"